<div class="flex justify-content-end align-items-center">
  <i
    class="pi pi-cog p-text-secondary cursor-pointer mr-3"
    style="font-size: 1.5rem"
    (click)="op.toggle($event)"></i>

  <p-overlayPanel
    #op
    [style]="{ width: '150px' }"
    styleClass="dropdown-overlay-panel informer-overlay-panel">
    <ng-template pTemplate="">
      <p-listbox
        [options]="filterSearch"
        [checkbox]="true"
        [multiple]="true"
        [showToggleAll]="false"
        dataKey="name"
        [(ngModel)]="selectedFilterSearch"
        [metaKeySelection]="false"
        [listStyle]="{ 'max-height': '350px' }"
        [style]="{ border: 'none' }"
        (ngModelChange)="changeFilterSearch($event)"></p-listbox>
    </ng-template>
  </p-overlayPanel>

  <div class="p-input-icon-right w-full">
    <crm-input-text
      #searchInput
      [(value)]="queryParams.q"
      (valueChange)="search.next($event)"
      [showClear]="true"
      [isInputIconLeft]="true"
      icon="pi pi-search"
      placeholder="Поиск"
      class="w-full"
      (onFocus)="search.next(queryParams.q)"></crm-input-text>
  </div>
</div>

<div
  class="relative"
  *ngIf="searchResults$ | async as results">
  <div
    #searchWindow
    pTooltip="Чтобы скрыть, нажмите на Esc"
    [showDelay]="300"
    tooltipPosition="top"
    class="search-results">
    <div *ngIf="results.deals?.length">
      <div class="search-results__result-header fw-semibold"><i class="pi pi-briefcase text-base mr-2"></i>Сделки</div>
      <a
        *ngFor="let deal of results.deals"
        class="search-results__result"
        routerLink="/deal/card/{{ deal.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="deal.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="deal.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.projects?.length">
      <div class="search-results__result-header fw-semibold">
        <i class="pi pi-check-square text-base mr-2"></i>Задачи
      </div>
      <a
        *ngFor="let project of results.projects"
        class="search-results__result"
        routerLink="/project/card/{{ project.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="project.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="project.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.hdTasks?.length">
      <div class="search-results__result-header fw-semibold">
        <i class="pi pi-question-circle text-base mr-2"></i>HelpDesk
      </div>
      <a
        *ngFor="let task of results.hdTasks"
        class="search-results__result"
        routerLink="/helpdesk/task/card/{{ task.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="task.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="task.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.tasks?.length">
      <div class="search-results__result-header fw-semibold"><i class="pi pi-dollar text-base mr-2"></i>Платежи</div>
      <a
        *ngFor="let task of results.tasks"
        class="search-results__result"
        routerLink="/payments/task/card/{{ task.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="task.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="task.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.users?.length">
      <div class="search-results__result-header fw-semibold">
        <i class="pi pi-users text-base mr-2"></i>Пользователи
      </div>
      <a
        *ngFor="let user of results.users"
        class="search-results__result"
        routerLink="/user/card/{{ user.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="user.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="user.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.companies?.length">
      <div class="search-results__result-header fw-semibold"><i class="pi pi-building text-base mr-2"></i>Компании</div>
      <a
        *ngFor="let company of results.companies"
        class="search-results__result"
        routerLink="/company/my/card/{{ company.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="company.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="company.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.contragents?.length">
      <div class="search-results__result-header fw-semibold">
        <i class="pi pi-id-card text-base mr-2"></i>Контрагенты
      </div>
      <a
        *ngFor="let contragent of results.contragents"
        class="search-results__result"
        routerLink="/client/contragent/card/{{ contragent.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="contragent.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="contragent.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div
      *ngIf="
        !results.deals?.length &&
        !results.projects?.length &&
        !results.hdTasks?.length &&
        !results.tasks?.length &&
        !results.users?.length &&
        !results.companies?.length &&
        !results.contragents?.length
      "
      class="p-3 fw-semibold text-base">
      <i class="pi pi-search mr-2"></i>Ничего не найдено
    </div>
  </div>
</div>
